import { css } from 'styled-components';
import { BREAK_POINTS } from '../consts/media';
var styledCss = css;
export var breakPoint = function breakPoint(label, BREAK_POINT) {
  return function () {
    return css(["@media only screen and (min-width:", "){", ";}"], BREAK_POINT, styledCss.apply(void 0, arguments));
  };
};
export var SM = function SM() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return breakPoint('SM', BREAK_POINTS.SM.Min)(args);
};
export var MD = function MD() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return breakPoint('MD', BREAK_POINTS.MD.Min)(args);
};
export var LG = function LG() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return breakPoint('LG', BREAK_POINTS.LG.Min)(args);
};
export var XL = function XL() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return breakPoint('XL', BREAK_POINTS.XL.Min)(args);
};